import firebase from "firebase";

// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: "AIzaSyCnpF6WnRyNKNfOgufWcCoWbkXNo6GXLJI",
  authDomain: "clone-54ee8.firebaseapp.com",
  projectId: "clone-54ee8",
  storageBucket: "clone-54ee8.appspot.com",
  messagingSenderId: "618356804542",
  appId: "1:618356804542:web:107eceb7281b2af46587ef",
  measurementId: "G-TDHE4RTTPZ",
};

const firebaseApp = firebase.initializeApp(firebaseConfig);

const db = firebaseApp.firestore();
const auth = firebase.auth();
export { db, auth };
